
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed, watch } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Descriptions from '@/components/descriptions.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { ClockCircleOutlined, Descriptions, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      spinning: true
    })
    const moment = require('moment')
    watch(
      () => (props.pageSourceData || {}).Eve || [],
      () => {
        const _data = (props.pageSourceData || {}).Eve || []
        const list: any = []
        _data.forEach((item: any, i: number) => {
          let _new = false
          if (i === 0) _new = true
          list.push({
            title: moment(item.Date * 1000).format('YYYY-MM-DD'),
            key: 'time',
            new: _new,
            content: item.Content,
            opencontent: false,
            open: false,
            remarks: item.MS
          })
        })
        nextTick(() => {
          pageData.spinning = false
        })
        pageData.list = list
      },
      { deep: true }
    )
    function open(item: any) {
      item.open = !item.open
    }
    return {
      ...toRefs(pageData),
      open
    }
  }
})
